module.exports = __webpack_public_path__ + "img/ec.d8b5c15a.svg";